export const NUMBER_OF_TICKS = 3;
export const BAR_PADDING = '0.15rem';
export const BAR_WIDTH = '1rem';
export const BARS_HEIGHT = '8rem';
export const DIVIDER_WIDTH = '2.5rem';
export const LEGEND_WIDTH = '2.5rem';
export const LABEL_WIDTH = '2rem';